<div class="flex flex-col gap-1" >
    <app-entity-property-dropdown
        [disabled]="formControl?.disabled || disabled()"
        [entityName]="entityName()"
        [value]="items()[entityName()]"
        (onValueChange)="entityValueChanged(entityName(), $event)"
    ></app-entity-property-dropdown>
    @if((chosenEntities()?.length??0) > 1 && isInitialized) {
        <div class="flex flex-col gap-1 ml-5">
            <span class="text-muted-color">{{ 'entity-search-settings.connected-entities' | translate }}</span>
            @for (key of chosenEntities(); track key) {
                @let currentOption = getOptionForFieldName(key);
                @if (currentOption) {
                    <div class="flex gap-1 items-center">
                        <app-entity-property-dropdown
                            class="w-full"
                            [disabled]="formControl?.disabled || disabled()"
                            [entityName]="currentOption.type"
                            [outputPrefix]="currentOption"
                            [value]="items()[currentOption.fieldName]"
                            (onValueChange)="entityValueChanged(currentOption.fieldName, $event)"
                        ></app-entity-property-dropdown>
                        <p-button
                            [disabled]="formControl?.disabled || disabled() || !isInitialized"
                            icon="fa-solid fa-x"
                            [rounded]="true"
                            [text]="true"
                            severity="danger"
                            size="small"
                            (onClick)="removeEntity(currentOption)"
                        ></p-button>
                    </div>
                }
            }
        </div>
    }
    <p-select
        #entitySelect
        [options]="availableOptions()"
        (onChange)="newEntityChosen($event.value, entitySelect)"
        [placeholder]="'entity-search-settings.add-connected-entity' | translate"
        [optionLabel]="'label'"
        [disabled]="formControl?.disabled || disabled() || !isInitialized"
        appendTo="body"
    ></p-select>
</div>